// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/flash_background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/celebrate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/hole.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/timer.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/first-place-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/winner-celebrate.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  color: #FFFFFF;
  font-size: 12px;
  line-height: 18px;
}

.container {
  text-align: center;
  color: white;
  position: relative;
  background: linear-gradient(
    180deg, 
    #000000 5%, 
    #160E2D 30%, 
    #251640 67%
  );
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  overflow: hidden auto;
}

.blur {
  position: absolute;
  z-index: -1;
  filter: blur(10px);
}

.modal {
  text-align: center;
  color: white;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 20px 40px;
  overflow: hidden;
}

.container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  background-size: cover;
  mix-blend-mode: overlay;
  opacity: 0.7;
  z-index: 0;
}

.title {
  font-weight: 900;
  font-size: 47px;
  color: #FF7A00;
  margin: 0;
  z-index: 1;
}

.subtitle {
  color: white;
  font-weight: 900;
  font-size: 16px;
  z-index: 1;
}

.image-container {
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.main-image {
  width: 100%;
  max-width: 205px;
}

.task-cointainer {
  width: 100%;
  border: 2px solid #D9D9D9;
  border-radius: 20px;
  z-index: 1;
  background-color: #160D26;
}

.task-cointainer h3 {
  color: #FFFFFF;
  font-weight: 700;
  font-size: 15px;
  margin: 5px 10px;
}

.task-cointainer p {
  margin: 0 10px 10px;
}

.subscribe-container {
  border-radius: 15px;
  background: 
    /* Diamond Gradient */
    radial-gradient(rgba(255, 255, 255, 0.5) 0%, transparent 70%),
    /* Solid Color with 80% Opacity */
    rgba(142, 98, 223, 0.8);
  background-size: cover;
  width: 100%;
  z-index: 1;
  margin-top: 25px;
  margin-bottom: 40px;
}

.subscribe-container h2 {
  color: white;
  font-size: 24px;
  font-weight: 900;
}

.subscribe-container p.hint {
  font-size: 12px;
  margin: 0px 17px 20px;
}

.subscribe-container button {
  font-size: 10px;
  min-width: 125px;
}

button {
  color: white;
  border-radius: 10px;
  border: none;
  font-size: 12px;
  font-weight: 700;
  padding: 9px 10px;
  min-width: 137px;
  margin: 5px;
}

.orange-button {
  background-color: #FF7A00;
  
}

.marging-bottom {
  margin-bottom: 20px;
}

.blue-button {
  background-color: #00B2FF;
}

.white-container {
  background-color: white;
  border-radius: 15px;
  margin: 15px;
  color: #2B1A4B;
  padding: 10px;
}

.white-container p {
  color: #2B1A4B;
  margin-top: 0;
  font-weight: 500;
}

.main-container {
  flex: 1 1;
  z-index: 1;
}

#congratulation-image {
  position: relative;
  margin-bottom: -25px;
}

#congratulation-image::before {
  content: '';
  position: absolute;
  border-radius: 15px;
  background: 
    /* Diamond Gradient */
    radial-gradient(rgba(255, 255, 255, 0.5) 0%, transparent 70%),
    rgba(142, 98, 223, 1);
  background-size: cover;
  width: 100%;
  height: 400px;
  z-index: -1;
  left: 0px;
  top: 100px;
}

#congratulation-image::after {
  content: '';
  position: absolute;
  left: -20px;
  top: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  z-index: 0;
  width: 100%;
  height: 480px;
  padding: 0 20px;
}

#congratulation-image .main-image {
  max-width: 292px;
  position: relative;
  z-index: 1;
}

.congratulation-container {
  background-color: white;
  border-radius: 15px;
  color: #000000;
  padding: 5px 20px 20px;
}

.congratulation-container h1 {
  font-size: 24px;
  font-weight: 700;
}

.congratulation-container p {
  font-size: 16px;
  font-weight: 300;
  color: #000000;
  line-height: 24px;
}

.congratulation-container button {
  color: #000000;
  border: #8E62DF solid 2px;
  border-radius: 15px;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  background-color: white;
  margin: 0;
}

.points-container {
  background-color: #8E62DF;
  border-radius: 15px;
  width: 100%;
  z-index: 1;
  padding: 20px;
  box-sizing: border-box;
  color: white;
}

.points-container .points-header {
  display: flex;
  justify-content: space-between;
  align-items: top;
  margin-bottom: 10px;
}

.points-container .points-left {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.points-container .points-title {
  font-weight: 900;
  font-size: 22px;
}

.points-container .points-level {
  font-weight: 900;
  font-size: 10px;
  line-height: 4px;
}

.points-container .points-right {
  display: flex;
  text-align: right;
  flex-direction: column;
}

.points-container .points-coin {
  width: 30px;
  height: 26px;
  margin-right: 10px;
  margin-bottom: -5px;
}

.points-container .points-value {
  font-weight: 900;
  font-size: 22px;
}

.points-container .points-progress {
  font-weight: 900;
  font-size: 10px;
  line-height: 4px;
}

.points-container .progress-bar {
  background-color: #d3d3d3;
  border-radius: 12px;
  overflow: hidden;
  height: 8px;
  width: 100%;
  padding: 1px;
  box-sizing: border-box;
}

.points-container .progress {
  background: linear-gradient(
    90deg, 
    #928F8B 0%, 
    #FFFFFF 50%, 
    #928F8B 100%
  );
  height: 6px;
  width: 5%; /* Adjust this percentage to represent the progress */
  border-radius: 20px;
}

.invite-friends-container {
  position: relative;
  border-radius: 20px;
  background: linear-gradient(to bottom, #FFB067, #2B1A4B) border-box;
  border: 1px solid transparent;
  margin-top: 12px;
}

.invite-friends-container .content {
  background-color: #2B1A4B;
  border-radius: 20px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.invite-friends-container h3 {
  font-weight: 900;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.invite-friends-container h3 svg {
  margin-left: 4px;
}

.invite-friends-container p {
  font-weight: 400;
  font-size: 12px;
  margin: 0 auto 5px;
}

.invite-friends-container .input-container {
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
  margin-bottom: 15px;
  position: relative;
}

.invite-friends-container .input-container input {
  width: 100%;
  box-sizing: border-box;
  border: transparent;
  border-radius: 2px;
  height: 20px;
  padding: 2px 25px 2px 10px;
}

.invite-friends-container .input-container svg {
  position: absolute;
  top: 11px;
  right: 20px;
  color: black;
  transform: scaleX(-1);
}

.point-history-container {
  flex: 1 1;
  z-index: 1;
  margin-top: 10px;
}

.point-history-container table {
  background: #160D26;
  color: white;
  border-radius: 20px;
  border: 2px solid #2B1A4B;
  overflow: hidden;
  width: 100%;
  border-spacing: 0;
}

.point-history-container table thead {
  background: linear-gradient(
    83deg, 
    #38233F 3%, 
    #2B1A4B 38%, 
    #000000 100%
  );
  text-align: left;
  
}

.point-history-container table thead tr td {
  font-size: 14px;
  font-weight: 700;
  padding: 5px 20px 1px;
}

.point-history-container table tbody tr td {
  height: 49px;
  box-sizing: border-box;
  border-bottom: 1px solid #2B1A4B;
}

.point-history-container table tbody tr td.username {
  padding: 7px 10px 7px 20px;
}
.point-history-container table tbody tr td.username .username-container {
  text-align: left;
  text-transform: capitalize;
  font-size: 10px;
  line-height: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.point-history-container table tbody tr td.username .user-avatar {
  margin-right: 8px;
}
.point-history-container table tbody tr td.points-type {
  font-size: 10px;
  line-height: 15px;
  font-weight: 700;
  text-align: left;
  padding: 0 2px;
  text-transform: capitalize;
}
.point-history-container table tbody tr td.with-padding {
  padding-left: 20px;
}
.point-history-container table tbody tr td.points-count {
  font-size: 16px;
  font-weight: 700;
  text-align: right;
  padding-right: 20px;
}

img.round-avatar {
  margin-right: 8px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  box-sizing: border-box;
}

.point-history-container tfoot td {
  max-width: 320px;
  width: 100%;
  white-space: nowrap;
}

.dots-pagination-container {
  padding: 5px 10px;
  box-sizing: border-box;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.dots-pagination-container .dot {
  display: inline-block;
  margin: 0 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #333333;
}

.dots-pagination-container .dot.active {
  background-color: #FF7A00;
}

p.errorMessage {
  color: red;
  margin-bottom: 0;
}

.loader-container {
  position: absolute;
  left: 50%;
  margin-left: -37px;
  z-index: 2;
  top: 400px;
  text-align: center;
}

.loader-container p {
  color: white;
  text-align: center;
  font-weight: 900;
  font-size: 18px;
  margin: 0;
}

.custom-spinner {
  border: 5px solid #ffffff; /* Light grey */
  border-top: 5px solid transparent; /* Blue */
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 1s linear infinite;
  display: inline-block;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.footer {
  flex: 1 1;
  padding: 20px 0;
  position: relative;
  z-index: 1;
  margin-bottom: -40px;
}

.footer::before {
  content: '';
  position: absolute;
  top: -20px;
  left: -150px;
  right: -150px;
  height: 100%;
  background-color: #251640;
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
  z-index: -1;
}

.footer-title {
  font-weight: 700;
  font-size: 32px;
  color: #FF7A00;
  margin: 0;
}

.footer-subtitle {
  margin-top: 0;
  color: #D9D9D9;
  font-weight: 700;
  font-size: 15px;
}

.footer-ton-logo {
  height: 58px;
  width: 150px;
  margin: 0 auto;
}

.footer-ton-logo img {
  width: 100%;
}

.footer-subtitle2 {
  margin-bottom: 0;
  color: white;
  font-weight: 700;
  font-size: 15px;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 20px;
  font-size: 2rem;
  color: white;
}

.social-icons a {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #97969a;
}

.social-icons a.instagram {
  height: 35px;
  width: 35px;
}

.social-icons a.instagram:after {
  background: #97969a;
  height: 32px;
  width: 32px;
}

.social-icons a:after{
  content: '';
  z-index: -1;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  left: 0;
  margin: 0 auto;
  height: 25px;
  width: 25px;
  position: absolute;
  border-radius: 50%;
  background: white;
}

/* remove after 6th of november 12am */
.select-party-container.cast-vote {
  background: linear-gradient(
    180deg,
    #000000 5%,
    #160E2D 30%,
    #251640 67%
  );
}

.select-party-container.cast-vote:before {
  display: none;
}

.select-party-container.cast-vote .select-party-inner-wrap {
  z-index: 99;
  margin: 0 auto;
  max-width: 350px;
  width: 100%;
  min-height: 100vh;
}

.select-party-container.cast-vote .select-party {
  margin-bottom: 40px;
  border-radius: 20px;
  border: 2px solid rgb(43, 26, 75);
  background: rgb(22, 13, 38);
}

.select-party-container.cast-vote .select-party-title-wrap {
  padding: 13px 5px 11px 5px;
  border-top-right-radius: 18px;
  border-top-left-radius: 18px;
  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;
}

.select-party-container.cast-vote .select-party-title-wrap p {
  margin: 0;
  font-weight: 900;
  font-size: 14px;
  color: #fff;
  text-transform: uppercase;
}


.select-party-container.cast-vote .select-party-content {
  margin-bottom: 21px;
  padding: 21px 27px 0 27px;
  box-sizing: border-box;
}


.select-party-container.cast-vote .select-party-content-bottom {
  padding: 0 10px 23px 10px;
}


.select-party-container.cast-vote .title {
  margin-bottom: 10px;
  font-family: Poppins, sans-serif;
  font-weight: 900;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
  text-shadow: 0 0 10px #8e62df;
}

.select-party-container.cast-vote .subtitle {
  margin: 0 0 4px 0;
  font-family: Poppins, sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #ff7a00;
  max-width: unset;
}

.select-party-container.cast-vote .subtitle-second {
  position: relative;
  z-index: 1;
  margin: 0 0 17px 0;
  font-family: Poppins, sans-serif;
  font-weight: 900;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px 0 #2B1A4B, -2px 2px 0 #2B1A4B, -2px -2px 0 #2B1A4B, 2px -2px 0 #2B1A4B;
}

.select-party-container.cast-vote h3:before {
  content: attr(data-content);
  position: absolute;
  color: inherit;
  font-size: inherit;
  text-shadow: 0 0 10px #ffb067;
  z-index: -1;
}

.select-party-container.cast-vote .vote-card-wrap {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.select-party-container.cast-vote .vote-card {
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: transparent;
  cursor: pointer;
  box-sizing: border-box;
}

.select-party-container.cast-vote .vote-card.selected .image-container {
  transform: scale(1.1);
}

.select-party-container.cast-vote .vote-card.zoom-out .image-container {
  transform: scale(0.9);
  opacity: 0.5;
}


.select-party-container.cast-vote .vote-card.zoom-out .team-card-btn {
  color: #808080;
  background: #803d00;

}

.select-party-container.cast-vote .vote-card h3 {
  margin: 0;
}

.select-party-container.cast-vote .vote-card .image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 17px;
  height: 120px;
  width: 120px;
  transition: 0.3s ease-out;
}

.select-party-container.cast-vote .vote-card .image-container img {
  display: block;
  height: 100%;
  width: auto;
}

.select-party-container.cast-vote .vote-card .team-card-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;
  width: 120px;
  height: 42px;
  font-family: Poppins, sans-serif;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 100px;
  background: #ff7a00;
  box-sizing: border-box;
}

.select-party-container.cast-vote .select-party-prize-title {
  margin: 0;
  font-family: Poppins, sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #ff7a00;
}

.select-party-container.cast-vote .select-party-prize-points {
  margin: 0;
  font-family: Poppins, sans-serif;
  font-weight: 900;
  font-size: 30px;
  line-height: 1;
  text-align: center;
  color: #fff;
}
/* remove after 6th of november 12am */


.select-party-container {
  background: linear-gradient(180deg, #160E2D 5%, #0f0a1f 30%, #0a0614 67%);
  box-sizing: border-box;
}

.select-party-container .select-party-inner-wrap {
  z-index: 99;
  margin: 0 auto;
  max-width: 350px;
  width: 100%;
}

.select-party-container h1 {
  margin-bottom: 16px;
  font-family: Poppins, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  text-transform: uppercase;
  text-align: center;
  color: #ff7a00;
}

.select-party-container h2 {
  max-width: 225px;
  width: 100%;
  margin: 0 auto 48px auto;
  font-family: Poppins, sans-serif;
  font-weight: 900;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  text-shadow: 0 0 10px #8e62df;
}

.select-party-container .team-card-wrap {
  display: flex;
  justify-content: space-between;
  margin-bottom: 64px;
}

.select-party-container .team-card {
  padding: 10px;
  height: 345px;
  max-width: 166px;
  width: 100%;
  border: 1px solid #961818;
  border-radius: 20px;
  box-shadow: 0 0 5px 0 #f00;
  background: linear-gradient(180deg, rgba(239, 36, 36, 0.5) 0%, rgba(132, 22, 22, 0.5) 100%);
  transition: 0.3s ease-out;
  cursor: pointer;
  box-sizing: border-box;
}

.select-party-container .team-card.selected {
  transform: scale(1.1);
}

.select-party-container .team-card.zoom-out {
  transform: scale(0.9);
  opacity: 0.8;
}

.select-party-container .team-card h3 {
  font-family: Poppins, sans-serif;
  font-weight: 900;
  font-size: 18px;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
}

.select-party-container .team-card .team-card-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 17px 0;
  height: 100%;
  border-radius: 12px;
  background: linear-gradient(180deg, #ef2424 0%, #841616 100%);
  transition: all 300ms ease;
  box-sizing: border-box;
}

.select-party-container .team-card.selected .team-card-inner:before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 12px;
  background: linear-gradient(0deg, rgb(192, 92, 0), rgb(255, 176, 103));
  z-index: -1;
}

.select-party-container .team-card.blue {
  border: 1px solid #000aff;
  box-shadow: 0 0 5px 0 #000aff;
  background: linear-gradient(180deg, rgba(0, 10, 255, 0.5) 0%, rgba(25, 34, 115, 0.5) 100%);
}

.select-party-container .team-card.blue .team-card-inner {
  background: linear-gradient(180deg, #3345ec 0%, #192273 100%);
}

.select-party-container .team-card h3 {
  margin: 0;
}

.select-party-container .team-card .image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 253px;
  width: 130px;
}

.select-party-container .team-card .image-container img {
  display: block;
  height: 100%;
  width: auto;
}

.select-party-container .button-large {
  padding: 16px 24px;
}

.select-party-title-wrap {
  padding: 13px 5px 11px 5px;
  border-top-right-radius: 18px;
  border-top-left-radius: 18px;
  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;
}

.select-party-title-wrap p {
  margin: 0;
  font-weight: 900;
  font-size: 14px;
  color: #fff;
  text-transform: uppercase;
}

.button-large {
  position: relative;
  padding: 20px 24px;
  max-width: 345px;
  width: 100%;
  font-family: Poppins, sans-serif;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 1px;
  text-align: center;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  border-radius: 100px;
  background: linear-gradient(0deg, #C05C00 0%, #FFB067 100%);
  cursor: pointer;
}

.button-large:before {
  content: '';
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border-radius: 100px;
  background: linear-gradient(100deg, rgb(192, 92, 0), rgb(255, 176, 103));
  z-index: -1;
}

.button-large:disabled {
  pointer-events: none;
  color: #2c1500;
  text-shadow: unset;
  border: 3px solid #321d09;
  background: #854000;
}

.button-large:disabled:before {
  display: none;
}

.game-container {
  text-align: center;
  color: white;
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0 0 20px 0;
  overflow: hidden auto;
  background: linear-gradient(180deg, #000 12.25%, #160e2d 47.37%, #251640 71%, #0f0a1e 82.2%);
}

.game-container-inner {
  position: relative;
  z-index: 1;
  padding: 24px 20px 40px 20px;
  overflow: hidden auto;
}

.game-container .board {
  max-width: 345px;
  width: 100%;
  margin: 0 auto 32px auto;
  border: 2px solid rgb(43, 26, 75);
  border-radius: 20px;
  background: #160d26;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.5);
}

.game-container-inner.started .board .board-title-main {
  display: none;
}

.game-container-inner.started .board .board-title-active {
  display: flex;
}

.game-container-inner.started .board .board-inner {
  background: linear-gradient(135.87deg, rgb(56, 35, 63) 2.826%,rgb(43, 26, 75) 37.34%,rgb(255, 122, 0) 97.104%);
}

.game-container .board .board-inner {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: linear-gradient(135.87deg, rgb(56, 35, 63) 2.826%,rgb(43, 26, 75) 37.34%,rgb(0, 0, 0) 97.104%);
}

.game-container .board .board-title {
  padding: 16px 10px 13px 10px;
  height: 56px;
  border-bottom: 1px solid rgb(22, 14, 45);
  box-sizing: border-box;
  text-transform: uppercase;
}

.game-container .board .board-title-active {
  display: none;
  padding: 0 14px;
  justify-content: space-between;
}

.game-container .board .board-title-active .points {
  display: flex;
  align-items: center;
}

.game-container .board .board-title-active .points span {
  display: inline-block;
  margin-left: 13px;
  font-family: Poppins, sans-serif;
  font-weight: 900;
  font-size: 23px;
  line-height: 1;
  color: #fff;
  text-shadow: -2px 0 #2B1A4B, 0 2px #2B1A4B, 2px 0 #2B1A4B, 0 -2px #2B1A4B;
}

.game-container .board h2 {
  margin: 0;
  font-family: Poppins, sans-serif;
  font-size: 18px;
  font-weight: 900;
  line-height: 27px;
  color: #fff;
}

.game-container .board-info {
  display: flex;
  font-family: Poppins, sans-serif;
}

.game-container .board-info .board-info-column {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 23px 14px 24px;
  width: 50%;
}

.game-container .board-info .board-info-column:first-child {
  border-right: 1px solid #160e2d;
}

.game-container .board-info .board-info-title {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
}

.game-container .board-info .board-info-value {
  font-size: 12px;
  font-weight: 900;
  line-height: 18px;
}

.game-container .board-teams-coins {
  display: flex;
}

.game-container .board-team-column {
  padding: 6px 6px 6px 23px;
  width: 50%;
  text-align: left;
}

.game-container .board-team-column:first-child {
  border-right: 1px solid #2b1a4b;
}

.game-container .board-team {
  position: relative;
  display: inline-block;
  margin: 0;
  padding-left: 28px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
}

.game-container .board-team span {
  font-weight: 700;
}

.game-container .board-team:before {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background: #000aff;
}

.game-container .board-team.red:before {
  background: #ef2424
}

.game-container .politics-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0;
  grid-row-gap: 0;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
}

.game-container .politics-grid .cell {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 93px;
}

.game-container .politics-grid .cell:before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 80px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
}

.game-container-inner:not(.started) .politics-grid .politic {
  border-radius: unset;
}

.game-container-inner:not(.started) .politics-grid .politic:before {
  bottom: 2px;
  border: 1px solid;
  border-radius: 50%;
}

.game-container-inner:not(.started) .politics-grid .politic.blue:before {
  border-color: #000aff;
}

.game-container-inner:not(.started) .politics-grid .politic.red:before {
  border-color: #ef2424;
}

.game-container-inner:not(.started) .politics-grid .cell:nth-child(1) .politic-head img {
  width: 118px;
}

.game-container-inner:not(.started) .politics-grid .cell:nth-child(4) .politic-head {
  width: 72px;
}

.game-container-inner:not(.started) .politics-grid .cell:nth-child(4) .politic-head img {
  width: 121px;
}

.game-container-inner:not(.started) .politics-grid .cell:nth-child(6) .politic-head img {
  width: 115px;
}

.game-container-inner:not(.started) .politics-grid .politic-head {
  transform: translateY(8px);
}

.game-container .politics-grid .politic {
  flex-direction: column;
  border-radius: 50%;
  overflow: hidden;
}

.game-container .politics-grid .politic.hide {
  pointer-events: none;
}

.game-container .politics-grid .politic-notifications {
  z-index: 2;
  position: absolute;
  top: 5px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 100px;
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.5);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  outline: 0;
  animation: fadeInUp 0.2s ease-out forwards;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }
  100% {
    opacity: 1;
    transform: translateY(10px);
  }
}

.game-container .politics-grid .politic-notifications span {
  margin-left: 5px;
  font-weight: 900;
  font-size: 18px;
  text-align: right;
  color: #fff;
}

.game-container .politics-grid .politic-head {
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 76px;
  width: 70px;
  margin: 0 auto;
  border-radius: 25%;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  outline: 0;
  transform: translateY(10px);
  transition: opacity 0.5s ease;
}

.game-container .politics-grid .politic.hide .politic-head {
  opacity: 0;
}

.game-container .politics-grid .politic-head img {
  width: 120px;
}

@keyframes moveY {
  0% {
    transform: translateY(85px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(85px);
  }
}

.game-container .button-large {
  margin-top: 40px;
  max-width: 191px;
}

.game-container .button-large.button-timer {
  background: #160d26;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  cursor: default;
}

.game-container .button-large.button-timer span {
  color: #ff7a00;
}

.game-container .button-large.button-sand {
  position: relative;
  padding: 12px 5px 12px 25px;
  font-weight: 700;
  font-size: 29px;
  text-shadow: 1px 2px 0 #000, -2px 2px 0 #000, -2px -1px 0 #000, 1px -1px 0 #000;
  background: linear-gradient(180deg, #653db1 0%, #2b1a4b 100%);
  cursor: default;
}

.game-container .button-large.button-sand:after {
  content: '';
  position: absolute;
  top: -30px;
  left: -15px;
  width: 100px;
  height: 104px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  background-size: 112px;
}

.game-container .button-large.button-sand.times-up {
  max-width: 264px;
  font-size: 25px;
  letter-spacing: 0;
  background: #8e62df;
  cursor: default;
}

.tabs-container {
  padding-bottom: 70px !important;
  justify-content: space-between;
  overflow: hidden auto;
  touch-action: none;
  box-sizing: border-box;
}

.tabs-router {
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
  min-height: 55px;
}

.tabs-router.white {
  margin-bottom: 0;
}

.tabs-router.white a.active {
  border-color: transparent;
}

.tabs-router.white a.active svg {
  stroke: white;
}

.tabs-router ul {
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  list-style: none;
  border-bottom: 1px solid #302e2e;
  box-sizing: border-box;
}

.tabs-router ul li {
  width: 50%;
}

.tabs-router a {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 5px;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  color: #7a7a7a;
  text-decoration: unset;
}

.tabs-router a.active {
  color: #fff;
}

.tabs-router a.active svg {
  stroke: #FF7A00;
}

.tabs-router a.active {
  border-bottom: 3px solid #ff7a00;
}

.tabs-router a svg {
  margin-right: 10px;
  stroke: #7A7A7A;
}

.tabs-router.bottom-menu {
  z-index: 1;
  position: fixed;
  bottom: 0;
  margin-bottom: 0;
  max-width: unset;
  background: #000;
}

.tabs-router.bottom-menu ul {
  padding: 0 23px;
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
  border-bottom: unset;
  border-top: 1px solid #302e2e;
}

.tabs-router.bottom-menu li {
  width: calc(100% / 5);
}

.tabs-router.bottom-menu a {
  flex-direction: column;
  border-top: 3px solid transparent;
  font-size: 9px;
  line-height: 22px;
}

.tabs-router.bottom-menu a.active {
  font-weight: 600;
  border-bottom: unset;
  border-top: 3px solid #ff7a00;
}

.tabs-router.bottom-menu a .svg-wrap {
  display: flex;
  justify-content: center;
  justify-items: center;
  height: 24px;
  width: 24px;
}

.tabs-router.bottom-menu a svg {
  margin-right: 0;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: blur(30px);
          backdrop-filter: blur(30px);
  background: rgba(0, 0, 0, 0.75);
  overflow: hidden;
  overflow-y: auto;
  transition: opacity 0.3s;
  z-index: 999;
  box-sizing: border-box;
}

.modal.vote-modal {
  background: linear-gradient(
    180deg,
    #000000 5%,
    #160E2D 30%,
    #251640 67%
  );
}

.modal.vote-modal .modal-wrapper {
  display: block;
  min-height: 100vh;
}

.modal.vote-modal .modal-content {
  height: 100vh;
  margin-right: auto;
  margin-left: auto;
  border-radius: unset;
  border: none;
  background: unset;
}

.modal.vote-modal .modal-content h2 {
  max-width: unset;
}

.modal.vote-modal .vote-modal-close {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px auto 0 auto;
  padding: 0;
  height: 48px;
  width: 48px;
  min-width: unset;
  cursor: pointer;
  background: unset;
}

.modal.vote-modal .vote-modal-close img {
  height: 100%;
}

.modal-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100%;
}

.modal-content {
  position: relative;
  margin: 20px;
  width: 100%;
  max-width: 345px;
  border-radius: 20px;
  border: 2px solid rgb(43, 26, 75);
  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;
  padding: 43px 20px 37px 20px;
  transform: translateY(-50px);
  transition: opacity 0.3s, transform 0.3s;
  box-sizing: border-box;
}

.modal-content h2 {
  margin: 0;
  font-weight: 900;
  font-size: 20px;
  text-align: center;
  color: #fff;
  text-shadow: 0 0 10px #8e62df;
}

.modal-content .points {
  display: flex;
  justify-content: center;
  margin: 26px 0;
}

.modal-content .points span {
  position: relative;
  display: inline-block;
  margin-left: 12px;
  font-family: Poppins, sans-serif;
  font-weight: 900;
  font-size: 38px;
  line-height: 1;
  color: #fff;
  text-shadow:
    3px 3px 0 #2B1A4B,
    -3px 3px 0 #2B1A4B,
    -2px -3px 0 #2B1A4B,
    2px -3px 0 #2B1A4B;
}

.modal-content .points span:before {
  content: attr(data-content);
  position: absolute;
  color: inherit;
  font-weight: 900;
  font-size: 38px;
  text-shadow: 0 0 23px #ffb067;
  z-index: -1;
}

.modal-content p {
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  color: #fff;
}

.modal-content .button-large {
  margin-top: 25px;
  max-width: 279px;
}

.scores-container {
  text-align: center;
  color: white;
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0 0 20px 0;
  background: linear-gradient(180deg, #000 12.25%, #160e2d 47.37%, #251640 71%);
}

.scores-inner {
  padding-top: 24px;
  margin: 0 auto;
  max-width: 768px;
  width: 100%;
  overflow: hidden auto;
}

.scores-inner .users-list .loader-container {
  position: static;
  top: auto;
  right: 0;
  left: 0;
  margin: auto;
  padding: 47px 0 27px 0;
}

.scores-inner .users-list .loader-container p {
  display: none;
}

.trigger {
  height: 20px;
  background: transparent;
}

.scores-main {
  position: relative;
  z-index: 1;
  padding: 0 24px 17px 24px;
}

.my-info .user-item {
  padding: 14px 25px 14px 14px;
  border-radius: 20px;
  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #ff7a00 100%);
}

.my-info .user-item .user-points span {
  margin-left: 21px;
}

.top-users {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0 0 60px 0;
  list-style: none;
}

.top-users .top-user-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 74px;
  padding: 0 25px;
  box-sizing: border-box;
}

.top-users .top-user-item .user-title {
  margin-bottom: 4px;
  text-align: center;
}

.top-users .top-user-item .user-points {
  margin-bottom: 10px;
  font-size: 14px;
  text-shadow: 1px 1px 0 #2B1A4B, -1px 1px 0 #2B1A4B, -1px -1px 0 #2B1A4B, 1px -1px 0 #2B1A4B;
}

.top-users .top-user-item .user-points span:before {
  content: attr(data-content);
  position: absolute;
  color: inherit;
  font-size: 14px;
  text-shadow: 0 0 10px #ffb067;
  z-index: -1;
}

.top-users .top-user-item .avatar-wrap {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.top-users .top-user-item .user-rank {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -56px;
  margin: auto;
  display: flex;
  justify-content: center;
}

.top-users .top-user-item .user-rank span {
  position: absolute;
  top: 13px;
  right: 0;
  left: 0;
  margin: auto;
  text-align: center;
  font-size: 20px;
  color: #000;
}

.top-users .top-user-item.first-place {
  position: relative;
  margin-top: 0;
  padding-top: 45px;
  width: 137px;
}

.top-users .top-user-item.first-place:before {
  content: '';
  z-index: -1;
  position: absolute;
  top: 18px;
  width: 137px;
  height: 246px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
}

.top-users .top-user-item.first-place .user-avatar {
  border-color: transparent !important;
  background: linear-gradient(
    to right,
    rgb(255, 157, 67),
    rgb(255, 255, 255),
    rgb(255, 176, 103),
    rgb(255, 122, 0)
  );
}

.top-users .top-user-item.first-place .user-points {
  margin-bottom: 5px;
}

.top-users .top-user-item.first-place .user-rank {
  bottom: -54px;
}

.users-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.users-list .user-title {
  color: #fff;
}

.user-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 39px 16px 24px;
  margin-bottom: 5px;
  background: #0f0a1e;
}

.user-item .user-item-left {
  display: flex;
  align-items: center;
}

.user-avatar {
  position: relative;
  border-radius: 100%;
  flex-shrink: 0;
  box-sizing: border-box;
  -webkit-user-select: none;
          user-select: none;
}

.user-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 100%;
}

.user-avatar .user-avatar-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-weight: normal;
  text-transform: uppercase;
  border-radius: 50%;
  overflow: hidden;
}

.user-avatar .user-avatar-placeholder span {
  opacity: .9;
  filter: saturate(0.8);
}

.user-item .user-item-info {
  margin-left: 15px;
}

.user-title {
  margin: 0 0 2px 0;
  text-align: left;
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  color: #ff7a00;
}

.user-rank {
  margin: 0;
  text-align: left;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
}

.user-points {
  position: relative;
  font-weight: 900;
  font-size: 14px;
  text-align: center;
  color: #fff;
  text-shadow: 0 0 10px #8e62df;
}

.user-item .user-points {
  border-left: 1px solid #2d1b4b;
}

.user-item .user-points span {
  margin-left: 31px;
}

.coming-soon {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #251640;
}

.coming-soon .coming-soon-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 23px auto;
  width: 70px;
  height: 70px;
  border-radius: 100px;
  background: #2b1a4b;
}

.coming-soon .coming-soon-icon svg {
  fill: none;
  stroke: #916e9c;
}

.coming-soon h1 {
  font-weight: 900;
  font-size: 20px;
  text-align: center;
  color: #fff;
  text-shadow: 0 0 10px #8e62df;
}

.coming-soon p {
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  color: #916e9c;
}

.earn-points-container {
  padding: 26px 26px 45px 26px;
  overflow: hidden auto;
}

.earn-points-container ul {
  padding: 0;
  margin: 0 auto;
  max-width: 768px;
  width: 100%;
  list-style: none;
}

.earn-points-item {
  position: relative;
  margin-bottom: 17px;
  border-radius: 20px;
  border: 2px solid rgb(43, 26, 75);
  background: rgb(22, 13, 38);
}

.earn-points-item-inactive {
  position: absolute;
  background-color: #0F0A1E80;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.earn-points-item:last-of-type {
  margin-bottom: 0;
}

.earn-points-item.done .earn-points-bar {
  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;
}

.earn-points-item .earn-points-bar {
  border-top-right-radius: 18px;
  border-top-left-radius: 18px;
  height: 40px;
  width: 100%;
  background: linear-gradient(
    135.87deg,
    rgb(56, 35, 63) 2.841%,
    rgb(43, 26, 75) 37.264%,
    rgb(255, 122, 0) 96.87%);
}

.earn-points-item .earn-points-bar img {
  margin-top: 21px;
}

.earn-points-item .earn-points-content {
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 33px 10px 26px 10px;
  box-sizing: border-box;
}

.earn-points-item h2 {
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 22px;
  line-height: 109%;
  text-align: center;
  color: #fff;
}

.earn-points-item .earn-points-title {
  margin: 0 0 6px 0;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  text-transform: uppercase;
  color: #ff7a00;
}

.earn-points-item .earn-points-value {
  position: relative;
  margin-bottom: 14px;
  font-weight: 900;
  font-size: 24px;
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px 0 #2B1A4B, -2px 2px 0 #2B1A4B, -2px -2px 0 #2B1A4B, 2px -2px 0 #2B1A4B;
}

.earn-points-item .earn-points-value:before {
  content: attr(data-content);
  position: absolute;
  color: inherit;
  font-size: inherit;
  text-shadow: 0 0 10px #ffb067;
  z-index: -1;
}

.earn-points-item .button-wrap {
  width: 100%;
}

.earn-points-item .button-large {
  margin: 3px;
  padding: 14px 5px;
  min-width: auto;
  max-width: 120px;
  font-size: 14px;
}

.earn-points-item .button-large.button-pending {
  pointer-events: none;
  background: linear-gradient(180deg, #653db1 0%, #2b1a4b 100%);
}

.earn-points-item .button-large.button-pending:before {
  background: linear-gradient(180deg, #2b1a4b 0%, #653db1 100%);
}

.earn-points-item .button-large.button-done {
  position: relative;
  margin: 0;
  padding-left: 58px;
  max-width: 125px;
  text-align: left;
  pointer-events: none;
  text-shadow: unset;
  border: 3px solid #321d09;
  background: #854000;
}

.earn-points-item .button-large .button-inactive {
  position: relative;
  margin: 0;
  padding-left: 58px;
  max-width: 125px;
  text-align: left;
  pointer-events: none;
  text-shadow: unset;
  border: 3px solid #321d09;
  background: #854000;
}

.earn-points-item .button-large.button-done:before {
  content: '';
  z-index: 1;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 23px;
  border-radius: 100px;
  width: 25px;
  height: 25px;
  background: #05ff0080;
}

.earn-points-item .button-large.button-done:after {
  content: '';
  z-index: 2;
  position: absolute;
  top: 20px;
  left: 29px;
  width: 11px;
  height: 6px;
  color: #fff;
  border-bottom: solid 1px currentColor;
  border-left: solid 1px currentColor;
  transform: rotate(-45deg);
}

.earn-points-item p {
  margin-top: 23px;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  color: #fff;
}

.earn-points-msg {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  max-width: 260px;
  width: 100%;
  margin: 10px auto 0 auto;
}

.earn-points-msg svg {
  flex-shrink: 0;
  margin: -4px 5px 0 0;
}

.earn-points-msg p {
  margin: 0;
  font-size: 8px;
  line-height: 12px;
  color: #fff;
}

.account-container {
  padding-top: 24px;
  flex-grow: 1;
  overflow: hidden auto;
}

.account-inner {
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px 25px 24px;
  box-sizing: border-box;
}

.account-container .account-user {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
  font-weight: 900;
  font-size: 16px;
  text-align: center;
  color: #fff;
}

.account-container .account-user .user-avatar {
  margin-right: 12px;
}

.account-container .account-info {
  margin: 0 0 7px 0;
  padding: 0;
  list-style: none;
}

.account-container .account-info li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 24px 8px 24px;
  margin-bottom: 15px;
  font-weight: 900;
  font-size: 14px;
  color: #fff;
  border: 1px solid #000;
  border-radius: 15px;
  background: linear-gradient(180deg, #653db1 0%, #2b1a4b 100%);
  box-sizing: border-box;
}

.account-container .account-info li:first-child span {
  font-size: 23px;
}

.account-container .account-info li:last-child {
  margin-bottom: 0;
}

.account-container .account-info li span {
  display: flex;
  align-items: center;
}

.account-container .account-info li span img {
  margin-right: 10px;
}

.account-container .account-info h3 {
  margin: 0 10px 0 0;
  font-size: inherit;
  line-height: 21px;
  text-align: left;
  text-transform: uppercase;
}

.account-footnote {
  margin: 0 0 7px 0;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  color: #fff;
}

.account-stats {
  border: 2px solid rgb(43, 26, 75);
  border-radius: 20px;
  background: rgb(22, 13, 38);
}

.account-stats .account-stats-title {
  display: flex;
  align-items: center;
  padding: 0 22px;
  height: 40px;
  border-top-right-radius: 18px;
  border-top-left-radius: 18px;
  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;
}

.account-stats .account-stats-title h2 {
  margin: 0;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
  line-height: 21px;
}

.account-stats-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0;
  grid-row-gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.account-stats-list li {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 5px;
  border-top: 1px solid #2b1a4b;
}

.account-stats-list li:first-child,
.account-stats-list li:nth-child(2) {
  border-top: unset;
}

.account-stats-list li:nth-child(odd) {
  border-right: 1px solid #2b1a4b;
}

.account-stats-item-inner {
  display: flex;
  align-items: center;
  max-width: 140px;
  width: 100%;
}

.account-stats-left {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #2b1a4b;
}

.account-stats-right {
  padding-top: 6px;
  text-align: left;
}

.account-stats-right h3 {
  margin: 0;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #ff7a00;
}

.account-stats-right span {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #fff;
  white-space: pre;
}

.button-large.view-points {
  padding: 22px 24px;
  letter-spacing: 0;
  text-shadow: 1px 2px 0 #000, -2px 2px 0 #000, -2px -1px 0 #000, 1px -1px 0 #000;
  background: linear-gradient(180deg, #8e62df 0%,  #653db1 100%);
}

.button-large.view-points:before {
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
}

.election-list {
  position: relative;
  padding: 0;
  margin: 18px auto 14px auto;
  list-style: none;
  max-width: 768px;
  width: 100%;
}

.election-list:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  margin: auto;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  background: rgba(0, 0, 0, 0.01);
}

.election-list li {
  margin-bottom: 10px;
  border-radius: 20px;
  background: rgb(22, 13, 38);
}

.election-list li:last-child {
  margin-bottom: 0;
}

.election-list .election-title-wrap {
  padding: 13px 5px 11px 5px;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;
}

.election-list .election-title-wrap p {
  font-weight: 900;
  font-size: 14px;
  color: #fff;
}

.election-list .election-content {
  display: flex;
  justify-content: center;
  padding: 15px 23px 18px 17px;
  box-sizing: border-box;
}

.election-list .election-content-left {
  margin-right: 11px;
  height: 114px;
  width: 114px;
}

.election-list .election-content-left img {
  display: inline-block;
  width: 100%;
}

.election-list .election-content-right {
  display: flex;
  flex-direction: column;
}

.election-list .election-candidate {
  margin-bottom: 15px;
}

.election-list .election-candidate h3 {
  margin: 0;
  font-weight: 700;
  font-size: 24px;
  line-height: 1;
  text-align: center;
  color: #ff7a00;
}

.election-list .election-candidate p {
  font-weight: 900;
  font-size: 14px;
  text-align: center;
  color: #fff;
}

.election-list .election-actions-list {
  display: flex;
}

.election-list .election-actions-list button {
  margin: 0 0 5px 0;
  border: 1px solid #fff;
  border-radius: 100px;
  padding: 9px 24px;
  min-width: 80px;
  height: 30px;
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
}

.election-list .election-actions-list button.green {
  background: #00851d;
}

.election-list .election-actions-list button.red {
  background: #ef2424;
}

.election-list .election-actions-list p,
.election-list .election-actions-list span {
  font-weight: 900;
  font-size: 10px;
  line-height: 15px;
  text-align: center;
  color: #fff;
}

.election-list .election-action-wrap {
  display: flex;
  flex-direction: column;
  margin-right: 24px;
}

.election-list .election-action-wrap:last-of-type {
  margin-right: 0;
}

.vote-tweet.earn-points-item .earn-points-content {
  padding-bottom: 20px;
}

.vote-tweet.earn-points-item .earn-points-title {
  margin-bottom: 0;
}

.vote-tweet.earn-points-item .earn-points-value {
  margin-bottom: 30px;
}

.vote-tweet.earn-points-item .button-large {
  margin-bottom: 20px;
}

.bet-win-container {
  flex: 1 1;
  padding: 20px;
  overflow: hidden auto;
}

.bet-win-container:before {
  display: none;
}

.bet-win-container .bet-win-inner-wrap {
  z-index: 99;
  margin: 0 auto;
  max-width: 346px;
  width: 100%;
}

.bet-win-container .account-stats-title {
  justify-content: center;
  text-transform: uppercase;
}

.bet-win-container .account-stats-right span {
  font-size: 12px;
  line-height: 18px;
}

.bet-win {
  z-index: 1;
  position: relative;
  margin-bottom: 20px;
  border-radius: 20px;
  border: 2px solid rgb(43, 26, 75);
  background: rgb(22, 13, 38);
}

.bet-win-content {
  padding: 9px 20px 18px 20px;
  box-sizing: border-box;
}

.bet-win-content.winner {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
}

.bet-win-content.winner .title {
  color: #fff;
}

.bet-win-content .title {
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
  letter-spacing: 0.05em;
  text-align: center;
  color: #ff7a00;
}

.bet-win-content .points {
  margin: 0 0 10px 0;
  font-weight: 900;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #fff;
}

.bet-win-content .team-card-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.bet-win-content .team-card {
  padding: 9px;
  margin: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 20px;
  cursor: pointer;
  box-sizing: border-box;
}

.bet-win-content .team-card.no-cursor {
  cursor: default;
}

.bet-win-content .team-card.red {
  border-color: #961818;
  box-shadow: 0 0 5px 0 #f00;
  background: linear-gradient(180deg, rgba(239, 36, 36, 0.5) 0%, rgba(132, 22, 22, 0.5) 100%);
}

.bet-win-content .team-card.blue {
  border-color: #000aff;
  box-shadow: 0 0 5px 0 #000aff;
  background: linear-gradient(180deg, rgba(0, 10, 255, 0.5) 0%, rgba(25, 34, 115, 0.5) 100%);
}

.bet-win-content .team-card .image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3px;
  height: 120px;
  width: 120px;
  transition: 0.3s ease-out;
}

.bet-win-content .team-card .image-container img {
  display: block;
  height: 100%;
  width: auto;
}

.bet-win-content.winner .team-card h2 {
  color: #fff;
}

.bet-win-content .team-card h2 {
  margin: 0;
  font-weight: 900;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  color: #ff7a00;
}

.bet-win-content .team-card span {
  font-weight: 900;
  font-size: 24px;
  line-height: 1;
  text-align: center;
  color: #fff;
}

.bet-win-content .pending-text {
  font-weight: 900;
  font-size: 14px;
  text-align: center;
  color: #ff7a00;
  text-transform: uppercase;
}

.bet-win-content .bet-win-btn.closed {
  pointer-events: none;
  background: linear-gradient(180deg, #ff7a00 0%, rgba(255, 122, 0, 0.74) 100%);
}

.bet-win-content .bet-win-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 12px 24px;
  width: 121px;
  min-width: unset;
  height: 31px;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  border-radius: 100px;
  cursor: pointer;
  box-sizing: border-box;
}

.bet-win-content .bet-win-btn:before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.7);
  z-index: -1;
}

.bet-win-content .bet-win-btn.orange:disabled {
  pointer-events: none;
  background: #160d26;
}

.bet-win-content .bet-win-btn.orange:disabled:before {
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(180deg, #ff9d43 0%, #ff7a00 100%);
}

.bet-win-content .bet-win-btn.orange {
  background: linear-gradient(180deg, #ff9d43 0%, #ff7a00 100%);
}

.bet-win-content .bet-win-btn.purple {
  background: linear-gradient(180deg, #653db1 0%, rgba(101, 61, 177, 0.83) 100%);
}

.seed-ifo {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  padding: 15px 0;
  overflow-y: auto;
}

.seed-ifo-img {
  width: 100%;
  max-width: 388px;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iFAA8E;EAC9E,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB;;;;2BAIyB;EACzB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB;;;yBAGuB;EACvB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,oEAA0D;EAC1D,UAAU;EACV,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;;;;;GAKC;EACD,WAAW;EACX,SAAS,EAAE,qDAAqD;EAChE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mEAAmE;EACnE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;;;;;GAKC;EACD,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,iCAAiC,EAAE,SAAS;EAC5C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,OAAO;EACP,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE;;;;;GAKC;AACH;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,sFAAsF;AACxF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,2FAA2F;AAC7F;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;;AAGA;EACE,cAAc;EACd,mBAAmB;;AAErB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA,sCAAsC;;;AAGtC;EACE,yEAAyE;EACzE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,2FAA2F;EAC3F,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sEAAsE;EACtE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0FAA0F;AAC5F;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,sFAAsF;AACxF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,oBAAoB;EACpB,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wEAAwE;EACxE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,4FAA4F;AAC9F;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8GAA8G;AAChH;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,0GAA0G;AAC5G;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,wCAAwC;EACxC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6DAA8C;AAChD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mCAA2B;UAA3B,2BAA2B;EAC3B,4CAA4C;EAC5C,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iEAAiE;EACjE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,+EAA+E;EAC/E,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6DAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mCAA2B;UAA3B,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,sFAAsF;EACtF,4BAA4B;EAC5B,4BAA4B;EAC5B,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX;;;;sBAIoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,2FAA2F;AAC7F;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,6DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC;;;;;;GAMC;AACH;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX;;;;4BAI0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,2FAA2F;AAC7F;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;EAC5B,sFAAsF;AACxF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+EAA+E;EAC/E,8DAA8D;AAChE;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kCAA0B;UAA1B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,sFAAsF;AACxF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,6DAA0D;AAC5D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,2FAA2F;AAC7F;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["p {\n  color: #FFFFFF;\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.container {\n  text-align: center;\n  color: white;\n  position: relative;\n  background: linear-gradient(\n    180deg, \n    #000000 5%, \n    #160E2D 30%, \n    #251640 67%\n  );\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n  overflow: hidden auto;\n}\n\n.blur {\n  position: absolute;\n  z-index: -1;\n  filter: blur(10px);\n}\n\n.modal {\n  text-align: center;\n  color: white;\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px 20px 40px;\n  overflow: hidden;\n}\n\n.container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('./assets/flash_background.png') no-repeat center center fixed;\n  background-size: cover;\n  mix-blend-mode: overlay;\n  opacity: 0.7;\n  z-index: 0;\n}\n\n.title {\n  font-weight: 900;\n  font-size: 47px;\n  color: #FF7A00;\n  margin: 0;\n  z-index: 1;\n}\n\n.subtitle {\n  color: white;\n  font-weight: 900;\n  font-size: 16px;\n  z-index: 1;\n}\n\n.image-container {\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.main-image {\n  width: 100%;\n  max-width: 205px;\n}\n\n.task-cointainer {\n  width: 100%;\n  border: 2px solid #D9D9D9;\n  border-radius: 20px;\n  z-index: 1;\n  background-color: #160D26;\n}\n\n.task-cointainer h3 {\n  color: #FFFFFF;\n  font-weight: 700;\n  font-size: 15px;\n  margin: 5px 10px;\n}\n\n.task-cointainer p {\n  margin: 0 10px 10px;\n}\n\n.subscribe-container {\n  border-radius: 15px;\n  background: \n    /* Diamond Gradient */\n    radial-gradient(rgba(255, 255, 255, 0.5) 0%, transparent 70%),\n    /* Solid Color with 80% Opacity */\n    rgba(142, 98, 223, 0.8);\n  background-size: cover;\n  width: 100%;\n  z-index: 1;\n  margin-top: 25px;\n  margin-bottom: 40px;\n}\n\n.subscribe-container h2 {\n  color: white;\n  font-size: 24px;\n  font-weight: 900;\n}\n\n.subscribe-container p.hint {\n  font-size: 12px;\n  margin: 0px 17px 20px;\n}\n\n.subscribe-container button {\n  font-size: 10px;\n  min-width: 125px;\n}\n\nbutton {\n  color: white;\n  border-radius: 10px;\n  border: none;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 9px 10px;\n  min-width: 137px;\n  margin: 5px;\n}\n\n.orange-button {\n  background-color: #FF7A00;\n  \n}\n\n.marging-bottom {\n  margin-bottom: 20px;\n}\n\n.blue-button {\n  background-color: #00B2FF;\n}\n\n.white-container {\n  background-color: white;\n  border-radius: 15px;\n  margin: 15px;\n  color: #2B1A4B;\n  padding: 10px;\n}\n\n.white-container p {\n  color: #2B1A4B;\n  margin-top: 0;\n  font-weight: 500;\n}\n\n.main-container {\n  flex: 1;\n  z-index: 1;\n}\n\n#congratulation-image {\n  position: relative;\n  margin-bottom: -25px;\n}\n\n#congratulation-image::before {\n  content: '';\n  position: absolute;\n  border-radius: 15px;\n  background: \n    /* Diamond Gradient */\n    radial-gradient(rgba(255, 255, 255, 0.5) 0%, transparent 70%),\n    rgba(142, 98, 223, 1);\n  background-size: cover;\n  width: 100%;\n  height: 400px;\n  z-index: -1;\n  left: 0px;\n  top: 100px;\n}\n\n#congratulation-image::after {\n  content: '';\n  position: absolute;\n  left: -20px;\n  top: 0;\n  background: url('./assets/celebrate.png') no-repeat center;\n  z-index: 0;\n  width: 100%;\n  height: 480px;\n  padding: 0 20px;\n}\n\n#congratulation-image .main-image {\n  max-width: 292px;\n  position: relative;\n  z-index: 1;\n}\n\n.congratulation-container {\n  background-color: white;\n  border-radius: 15px;\n  color: #000000;\n  padding: 5px 20px 20px;\n}\n\n.congratulation-container h1 {\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.congratulation-container p {\n  font-size: 16px;\n  font-weight: 300;\n  color: #000000;\n  line-height: 24px;\n}\n\n.congratulation-container button {\n  color: #000000;\n  border: #8E62DF solid 2px;\n  border-radius: 15px;\n  width: 100%;\n  font-size: 20px;\n  font-weight: 700;\n  background-color: white;\n  margin: 0;\n}\n\n.points-container {\n  background-color: #8E62DF;\n  border-radius: 15px;\n  width: 100%;\n  z-index: 1;\n  padding: 20px;\n  box-sizing: border-box;\n  color: white;\n}\n\n.points-container .points-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: top;\n  margin-bottom: 10px;\n}\n\n.points-container .points-left {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.points-container .points-title {\n  font-weight: 900;\n  font-size: 22px;\n}\n\n.points-container .points-level {\n  font-weight: 900;\n  font-size: 10px;\n  line-height: 4px;\n}\n\n.points-container .points-right {\n  display: flex;\n  text-align: right;\n  flex-direction: column;\n}\n\n.points-container .points-coin {\n  width: 30px;\n  height: 26px;\n  margin-right: 10px;\n  margin-bottom: -5px;\n}\n\n.points-container .points-value {\n  font-weight: 900;\n  font-size: 22px;\n}\n\n.points-container .points-progress {\n  font-weight: 900;\n  font-size: 10px;\n  line-height: 4px;\n}\n\n.points-container .progress-bar {\n  background-color: #d3d3d3;\n  border-radius: 12px;\n  overflow: hidden;\n  height: 8px;\n  width: 100%;\n  padding: 1px;\n  box-sizing: border-box;\n}\n\n.points-container .progress {\n  background: linear-gradient(\n    90deg, \n    #928F8B 0%, \n    #FFFFFF 50%, \n    #928F8B 100%\n  );\n  height: 6px;\n  width: 5%; /* Adjust this percentage to represent the progress */\n  border-radius: 20px;\n}\n\n.invite-friends-container {\n  position: relative;\n  border-radius: 20px;\n  background: linear-gradient(to bottom, #FFB067, #2B1A4B) border-box;\n  border: 1px solid transparent;\n  margin-top: 12px;\n}\n\n.invite-friends-container .content {\n  background-color: #2B1A4B;\n  border-radius: 20px;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.invite-friends-container h3 {\n  font-weight: 900;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n}\n.invite-friends-container h3 svg {\n  margin-left: 4px;\n}\n\n.invite-friends-container p {\n  font-weight: 400;\n  font-size: 12px;\n  margin: 0 auto 5px;\n}\n\n.invite-friends-container .input-container {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 15px;\n  margin-bottom: 15px;\n  position: relative;\n}\n\n.invite-friends-container .input-container input {\n  width: 100%;\n  box-sizing: border-box;\n  border: transparent;\n  border-radius: 2px;\n  height: 20px;\n  padding: 2px 25px 2px 10px;\n}\n\n.invite-friends-container .input-container svg {\n  position: absolute;\n  top: 11px;\n  right: 20px;\n  color: black;\n  transform: scaleX(-1);\n}\n\n.point-history-container {\n  flex: 1;\n  z-index: 1;\n  margin-top: 10px;\n}\n\n.point-history-container table {\n  background: #160D26;\n  color: white;\n  border-radius: 20px;\n  border: 2px solid #2B1A4B;\n  overflow: hidden;\n  width: 100%;\n  border-spacing: 0;\n}\n\n.point-history-container table thead {\n  background: linear-gradient(\n    83deg, \n    #38233F 3%, \n    #2B1A4B 38%, \n    #000000 100%\n  );\n  text-align: left;\n  \n}\n\n.point-history-container table thead tr td {\n  font-size: 14px;\n  font-weight: 700;\n  padding: 5px 20px 1px;\n}\n\n.point-history-container table tbody tr td {\n  height: 49px;\n  box-sizing: border-box;\n  border-bottom: 1px solid #2B1A4B;\n}\n\n.point-history-container table tbody tr td.username {\n  padding: 7px 10px 7px 20px;\n}\n.point-history-container table tbody tr td.username .username-container {\n  text-align: left;\n  text-transform: capitalize;\n  font-size: 10px;\n  line-height: 15px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n.point-history-container table tbody tr td.username .user-avatar {\n  margin-right: 8px;\n}\n.point-history-container table tbody tr td.points-type {\n  font-size: 10px;\n  line-height: 15px;\n  font-weight: 700;\n  text-align: left;\n  padding: 0 2px;\n  text-transform: capitalize;\n}\n.point-history-container table tbody tr td.with-padding {\n  padding-left: 20px;\n}\n.point-history-container table tbody tr td.points-count {\n  font-size: 16px;\n  font-weight: 700;\n  text-align: right;\n  padding-right: 20px;\n}\n\nimg.round-avatar {\n  margin-right: 8px;\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  box-sizing: border-box;\n}\n\n.point-history-container tfoot td {\n  max-width: 320px;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.dots-pagination-container {\n  padding: 5px 10px;\n  box-sizing: border-box;\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.dots-pagination-container .dot {\n  display: inline-block;\n  margin: 0 5px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #333333;\n}\n\n.dots-pagination-container .dot.active {\n  background-color: #FF7A00;\n}\n\np.errorMessage {\n  color: red;\n  margin-bottom: 0;\n}\n\n.loader-container {\n  position: absolute;\n  left: 50%;\n  margin-left: -37px;\n  z-index: 2;\n  top: 400px;\n  text-align: center;\n}\n\n.loader-container p {\n  color: white;\n  text-align: center;\n  font-weight: 900;\n  font-size: 18px;\n  margin: 0;\n}\n\n.custom-spinner {\n  border: 5px solid #ffffff; /* Light grey */\n  border-top: 5px solid transparent; /* Blue */\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  animation: spin 1s linear infinite;\n  display: inline-block;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.footer {\n  flex: 1;\n  padding: 20px 0;\n  position: relative;\n  z-index: 1;\n  margin-bottom: -40px;\n}\n\n.footer::before {\n  content: '';\n  position: absolute;\n  top: -20px;\n  left: -150px;\n  right: -150px;\n  height: 100%;\n  background-color: #251640;\n  border-top-left-radius: 50%;\n  border-top-right-radius: 50%;\n  z-index: -1;\n}\n\n.footer-title {\n  font-weight: 700;\n  font-size: 32px;\n  color: #FF7A00;\n  margin: 0;\n}\n\n.footer-subtitle {\n  margin-top: 0;\n  color: #D9D9D9;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.footer-ton-logo {\n  height: 58px;\n  width: 150px;\n  margin: 0 auto;\n}\n\n.footer-ton-logo img {\n  width: 100%;\n}\n\n.footer-subtitle2 {\n  margin-bottom: 0;\n  color: white;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.social-icons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  font-size: 2rem;\n  color: white;\n}\n\n.social-icons a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  color: #97969a;\n}\n\n.social-icons a.instagram {\n  height: 35px;\n  width: 35px;\n}\n\n.social-icons a.instagram:after {\n  background: #97969a;\n  height: 32px;\n  width: 32px;\n}\n\n.social-icons a:after{\n  content: '';\n  z-index: -1;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  height: 25px;\n  width: 25px;\n  position: absolute;\n  border-radius: 50%;\n  background: white;\n}\n\n/* remove after 6th of november 12am */\n.select-party-container.cast-vote {\n  background: linear-gradient(\n    180deg,\n    #000000 5%,\n    #160E2D 30%,\n    #251640 67%\n  );\n}\n\n.select-party-container.cast-vote:before {\n  display: none;\n}\n\n.select-party-container.cast-vote .select-party-inner-wrap {\n  z-index: 99;\n  margin: 0 auto;\n  max-width: 350px;\n  width: 100%;\n  min-height: 100vh;\n}\n\n.select-party-container.cast-vote .select-party {\n  margin-bottom: 40px;\n  border-radius: 20px;\n  border: 2px solid rgb(43, 26, 75);\n  background: rgb(22, 13, 38);\n}\n\n.select-party-container.cast-vote .select-party-title-wrap {\n  padding: 13px 5px 11px 5px;\n  border-top-right-radius: 18px;\n  border-top-left-radius: 18px;\n  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;\n}\n\n.select-party-container.cast-vote .select-party-title-wrap p {\n  margin: 0;\n  font-weight: 900;\n  font-size: 14px;\n  color: #fff;\n  text-transform: uppercase;\n}\n\n\n.select-party-container.cast-vote .select-party-content {\n  margin-bottom: 21px;\n  padding: 21px 27px 0 27px;\n  box-sizing: border-box;\n}\n\n\n.select-party-container.cast-vote .select-party-content-bottom {\n  padding: 0 10px 23px 10px;\n}\n\n\n.select-party-container.cast-vote .title {\n  margin-bottom: 10px;\n  font-family: Poppins, sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  color: #fff;\n  text-transform: uppercase;\n  text-shadow: 0 0 10px #8e62df;\n}\n\n.select-party-container.cast-vote .subtitle {\n  margin: 0 0 4px 0;\n  font-family: Poppins, sans-serif;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: #ff7a00;\n  max-width: unset;\n}\n\n.select-party-container.cast-vote .subtitle-second {\n  position: relative;\n  z-index: 1;\n  margin: 0 0 17px 0;\n  font-family: Poppins, sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 2px 2px 0 #2B1A4B, -2px 2px 0 #2B1A4B, -2px -2px 0 #2B1A4B, 2px -2px 0 #2B1A4B;\n}\n\n.select-party-container.cast-vote h3:before {\n  content: attr(data-content);\n  position: absolute;\n  color: inherit;\n  font-size: inherit;\n  text-shadow: 0 0 10px #ffb067;\n  z-index: -1;\n}\n\n.select-party-container.cast-vote .vote-card-wrap {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0;\n}\n\n.select-party-container.cast-vote .vote-card {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  background: transparent;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.select-party-container.cast-vote .vote-card.selected .image-container {\n  transform: scale(1.1);\n}\n\n.select-party-container.cast-vote .vote-card.zoom-out .image-container {\n  transform: scale(0.9);\n  opacity: 0.5;\n}\n\n\n.select-party-container.cast-vote .vote-card.zoom-out .team-card-btn {\n  color: #808080;\n  background: #803d00;\n\n}\n\n.select-party-container.cast-vote .vote-card h3 {\n  margin: 0;\n}\n\n.select-party-container.cast-vote .vote-card .image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 17px;\n  height: 120px;\n  width: 120px;\n  transition: 0.3s ease-out;\n}\n\n.select-party-container.cast-vote .vote-card .image-container img {\n  display: block;\n  height: 100%;\n  width: auto;\n}\n\n.select-party-container.cast-vote .vote-card .team-card-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 9px 24px;\n  width: 120px;\n  height: 42px;\n  font-family: Poppins, sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  text-transform: uppercase;\n  text-align: center;\n  color: #fff;\n  border: 1px solid #fff;\n  border-radius: 100px;\n  background: #ff7a00;\n  box-sizing: border-box;\n}\n\n.select-party-container.cast-vote .select-party-prize-title {\n  margin: 0;\n  font-family: Poppins, sans-serif;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  color: #ff7a00;\n}\n\n.select-party-container.cast-vote .select-party-prize-points {\n  margin: 0;\n  font-family: Poppins, sans-serif;\n  font-weight: 900;\n  font-size: 30px;\n  line-height: 1;\n  text-align: center;\n  color: #fff;\n}\n/* remove after 6th of november 12am */\n\n\n.select-party-container {\n  background: linear-gradient(180deg, #160E2D 5%, #0f0a1f 30%, #0a0614 67%);\n  box-sizing: border-box;\n}\n\n.select-party-container .select-party-inner-wrap {\n  z-index: 99;\n  margin: 0 auto;\n  max-width: 350px;\n  width: 100%;\n}\n\n.select-party-container h1 {\n  margin-bottom: 16px;\n  font-family: Poppins, sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 21px;\n  text-transform: uppercase;\n  text-align: center;\n  color: #ff7a00;\n}\n\n.select-party-container h2 {\n  max-width: 225px;\n  width: 100%;\n  margin: 0 auto 48px auto;\n  font-family: Poppins, sans-serif;\n  font-weight: 900;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 0 0 10px #8e62df;\n}\n\n.select-party-container .team-card-wrap {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 64px;\n}\n\n.select-party-container .team-card {\n  padding: 10px;\n  height: 345px;\n  max-width: 166px;\n  width: 100%;\n  border: 1px solid #961818;\n  border-radius: 20px;\n  box-shadow: 0 0 5px 0 #f00;\n  background: linear-gradient(180deg, rgba(239, 36, 36, 0.5) 0%, rgba(132, 22, 22, 0.5) 100%);\n  transition: 0.3s ease-out;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.select-party-container .team-card.selected {\n  transform: scale(1.1);\n}\n\n.select-party-container .team-card.zoom-out {\n  transform: scale(0.9);\n  opacity: 0.8;\n}\n\n.select-party-container .team-card h3 {\n  font-family: Poppins, sans-serif;\n  font-weight: 900;\n  font-size: 18px;\n  text-align: center;\n  color: #fff;\n  text-transform: uppercase;\n}\n\n.select-party-container .team-card .team-card-inner {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 17px 0;\n  height: 100%;\n  border-radius: 12px;\n  background: linear-gradient(180deg, #ef2424 0%, #841616 100%);\n  transition: all 300ms ease;\n  box-sizing: border-box;\n}\n\n.select-party-container .team-card.selected .team-card-inner:before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 12px;\n  background: linear-gradient(0deg, rgb(192, 92, 0), rgb(255, 176, 103));\n  z-index: -1;\n}\n\n.select-party-container .team-card.blue {\n  border: 1px solid #000aff;\n  box-shadow: 0 0 5px 0 #000aff;\n  background: linear-gradient(180deg, rgba(0, 10, 255, 0.5) 0%, rgba(25, 34, 115, 0.5) 100%);\n}\n\n.select-party-container .team-card.blue .team-card-inner {\n  background: linear-gradient(180deg, #3345ec 0%, #192273 100%);\n}\n\n.select-party-container .team-card h3 {\n  margin: 0;\n}\n\n.select-party-container .team-card .image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  height: 253px;\n  width: 130px;\n}\n\n.select-party-container .team-card .image-container img {\n  display: block;\n  height: 100%;\n  width: auto;\n}\n\n.select-party-container .button-large {\n  padding: 16px 24px;\n}\n\n.select-party-title-wrap {\n  padding: 13px 5px 11px 5px;\n  border-top-right-radius: 18px;\n  border-top-left-radius: 18px;\n  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;\n}\n\n.select-party-title-wrap p {\n  margin: 0;\n  font-weight: 900;\n  font-size: 14px;\n  color: #fff;\n  text-transform: uppercase;\n}\n\n.button-large {\n  position: relative;\n  padding: 20px 24px;\n  max-width: 345px;\n  width: 100%;\n  font-family: Poppins, sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  letter-spacing: 1px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);\n  border-radius: 100px;\n  background: linear-gradient(0deg, #C05C00 0%, #FFB067 100%);\n  cursor: pointer;\n}\n\n.button-large:before {\n  content: '';\n  position: absolute;\n  top: -3px;\n  left: -3px;\n  right: -3px;\n  bottom: -3px;\n  border-radius: 100px;\n  background: linear-gradient(100deg, rgb(192, 92, 0), rgb(255, 176, 103));\n  z-index: -1;\n}\n\n.button-large:disabled {\n  pointer-events: none;\n  color: #2c1500;\n  text-shadow: unset;\n  border: 3px solid #321d09;\n  background: #854000;\n}\n\n.button-large:disabled:before {\n  display: none;\n}\n\n.game-container {\n  text-align: center;\n  color: white;\n  position: relative;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 20px 0;\n  overflow: hidden auto;\n  background: linear-gradient(180deg, #000 12.25%, #160e2d 47.37%, #251640 71%, #0f0a1e 82.2%);\n}\n\n.game-container-inner {\n  position: relative;\n  z-index: 1;\n  padding: 24px 20px 40px 20px;\n  overflow: hidden auto;\n}\n\n.game-container .board {\n  max-width: 345px;\n  width: 100%;\n  margin: 0 auto 32px auto;\n  border: 2px solid rgb(43, 26, 75);\n  border-radius: 20px;\n  background: #160d26;\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.5);\n}\n\n.game-container-inner.started .board .board-title-main {\n  display: none;\n}\n\n.game-container-inner.started .board .board-title-active {\n  display: flex;\n}\n\n.game-container-inner.started .board .board-inner {\n  background: linear-gradient(135.87deg, rgb(56, 35, 63) 2.826%,rgb(43, 26, 75) 37.34%,rgb(255, 122, 0) 97.104%);\n}\n\n.game-container .board .board-inner {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  background: linear-gradient(135.87deg, rgb(56, 35, 63) 2.826%,rgb(43, 26, 75) 37.34%,rgb(0, 0, 0) 97.104%);\n}\n\n.game-container .board .board-title {\n  padding: 16px 10px 13px 10px;\n  height: 56px;\n  border-bottom: 1px solid rgb(22, 14, 45);\n  box-sizing: border-box;\n  text-transform: uppercase;\n}\n\n.game-container .board .board-title-active {\n  display: none;\n  padding: 0 14px;\n  justify-content: space-between;\n}\n\n.game-container .board .board-title-active .points {\n  display: flex;\n  align-items: center;\n}\n\n.game-container .board .board-title-active .points span {\n  display: inline-block;\n  margin-left: 13px;\n  font-family: Poppins, sans-serif;\n  font-weight: 900;\n  font-size: 23px;\n  line-height: 1;\n  color: #fff;\n  text-shadow: -2px 0 #2B1A4B, 0 2px #2B1A4B, 2px 0 #2B1A4B, 0 -2px #2B1A4B;\n}\n\n.game-container .board h2 {\n  margin: 0;\n  font-family: Poppins, sans-serif;\n  font-size: 18px;\n  font-weight: 900;\n  line-height: 27px;\n  color: #fff;\n}\n\n.game-container .board-info {\n  display: flex;\n  font-family: Poppins, sans-serif;\n}\n\n.game-container .board-info .board-info-column {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 23px 14px 24px;\n  width: 50%;\n}\n\n.game-container .board-info .board-info-column:first-child {\n  border-right: 1px solid #160e2d;\n}\n\n.game-container .board-info .board-info-title {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.game-container .board-info .board-info-value {\n  font-size: 12px;\n  font-weight: 900;\n  line-height: 18px;\n}\n\n.game-container .board-teams-coins {\n  display: flex;\n}\n\n.game-container .board-team-column {\n  padding: 6px 6px 6px 23px;\n  width: 50%;\n  text-align: left;\n}\n\n.game-container .board-team-column:first-child {\n  border-right: 1px solid #2b1a4b;\n}\n\n.game-container .board-team {\n  position: relative;\n  display: inline-block;\n  margin: 0;\n  padding-left: 28px;\n  font-weight: 500;\n  font-size: 12px;\n  color: #fff;\n}\n\n.game-container .board-team span {\n  font-weight: 700;\n}\n\n.game-container .board-team:before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  background: #000aff;\n}\n\n.game-container .board-team.red:before {\n  background: #ef2424\n}\n\n.game-container .politics-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(3, 1fr);\n  grid-column-gap: 0;\n  grid-row-gap: 0;\n  max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.game-container .politics-grid .cell {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 93px;\n}\n\n.game-container .politics-grid .cell:before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  width: 80px;\n  height: 32px;\n  background: url('./assets/hole.png') no-repeat;\n}\n\n.game-container-inner:not(.started) .politics-grid .politic {\n  border-radius: unset;\n}\n\n.game-container-inner:not(.started) .politics-grid .politic:before {\n  bottom: 2px;\n  border: 1px solid;\n  border-radius: 50%;\n}\n\n.game-container-inner:not(.started) .politics-grid .politic.blue:before {\n  border-color: #000aff;\n}\n\n.game-container-inner:not(.started) .politics-grid .politic.red:before {\n  border-color: #ef2424;\n}\n\n.game-container-inner:not(.started) .politics-grid .cell:nth-child(1) .politic-head img {\n  width: 118px;\n}\n\n.game-container-inner:not(.started) .politics-grid .cell:nth-child(4) .politic-head {\n  width: 72px;\n}\n\n.game-container-inner:not(.started) .politics-grid .cell:nth-child(4) .politic-head img {\n  width: 121px;\n}\n\n.game-container-inner:not(.started) .politics-grid .cell:nth-child(6) .politic-head img {\n  width: 115px;\n}\n\n.game-container-inner:not(.started) .politics-grid .politic-head {\n  transform: translateY(8px);\n}\n\n.game-container .politics-grid .politic {\n  flex-direction: column;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.game-container .politics-grid .politic.hide {\n  pointer-events: none;\n}\n\n.game-container .politics-grid .politic-notifications {\n  z-index: 2;\n  position: absolute;\n  top: 5px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  border-radius: 100px;\n  backdrop-filter: blur(20px);\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n  user-select: none;\n  outline: 0;\n  animation: fadeInUp 0.2s ease-out forwards;\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(15px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(10px);\n  }\n}\n\n.game-container .politics-grid .politic-notifications span {\n  margin-left: 5px;\n  font-weight: 900;\n  font-size: 18px;\n  text-align: right;\n  color: #fff;\n}\n\n.game-container .politics-grid .politic-head {\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 76px;\n  width: 70px;\n  margin: 0 auto;\n  border-radius: 25%;\n  overflow: hidden;\n  user-select: none;\n  outline: 0;\n  transform: translateY(10px);\n  transition: opacity 0.5s ease;\n}\n\n.game-container .politics-grid .politic.hide .politic-head {\n  opacity: 0;\n}\n\n.game-container .politics-grid .politic-head img {\n  width: 120px;\n}\n\n@keyframes moveY {\n  0% {\n    transform: translateY(85px);\n  }\n  50% {\n    transform: translateY(10px);\n  }\n  100% {\n    transform: translateY(85px);\n  }\n}\n\n.game-container .button-large {\n  margin-top: 40px;\n  max-width: 191px;\n}\n\n.game-container .button-large.button-timer {\n  background: #160d26;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  cursor: default;\n}\n\n.game-container .button-large.button-timer span {\n  color: #ff7a00;\n}\n\n.game-container .button-large.button-sand {\n  position: relative;\n  padding: 12px 5px 12px 25px;\n  font-weight: 700;\n  font-size: 29px;\n  text-shadow: 1px 2px 0 #000, -2px 2px 0 #000, -2px -1px 0 #000, 1px -1px 0 #000;\n  background: linear-gradient(180deg, #653db1 0%, #2b1a4b 100%);\n  cursor: default;\n}\n\n.game-container .button-large.button-sand:after {\n  content: '';\n  position: absolute;\n  top: -30px;\n  left: -15px;\n  width: 100px;\n  height: 104px;\n  background: url('./assets/timer.png') no-repeat;\n  background-size: 112px;\n}\n\n.game-container .button-large.button-sand.times-up {\n  max-width: 264px;\n  font-size: 25px;\n  letter-spacing: 0;\n  background: #8e62df;\n  cursor: default;\n}\n\n.tabs-container {\n  padding-bottom: 70px !important;\n  justify-content: space-between;\n  overflow: hidden auto;\n  touch-action: none;\n  box-sizing: border-box;\n}\n\n.tabs-router {\n  max-width: 768px;\n  width: 100%;\n  margin: 0 auto;\n  min-height: 55px;\n}\n\n.tabs-router.white {\n  margin-bottom: 0;\n}\n\n.tabs-router.white a.active {\n  border-color: transparent;\n}\n\n.tabs-router.white a.active svg {\n  stroke: white;\n}\n\n.tabs-router ul {\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-bottom: 1px solid #302e2e;\n  box-sizing: border-box;\n}\n\n.tabs-router ul li {\n  width: 50%;\n}\n\n.tabs-router a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 5px;\n  font-weight: 500;\n  font-size: 12px;\n  text-align: center;\n  color: #7a7a7a;\n  text-decoration: unset;\n}\n\n.tabs-router a.active {\n  color: #fff;\n}\n\n.tabs-router a.active svg {\n  stroke: #FF7A00;\n}\n\n.tabs-router a.active {\n  border-bottom: 3px solid #ff7a00;\n}\n\n.tabs-router a svg {\n  margin-right: 10px;\n  stroke: #7A7A7A;\n}\n\n.tabs-router.bottom-menu {\n  z-index: 1;\n  position: fixed;\n  bottom: 0;\n  margin-bottom: 0;\n  max-width: unset;\n  background: #000;\n}\n\n.tabs-router.bottom-menu ul {\n  padding: 0 23px;\n  max-width: 768px;\n  width: 100%;\n  margin: 0 auto;\n  border-bottom: unset;\n  border-top: 1px solid #302e2e;\n}\n\n.tabs-router.bottom-menu li {\n  width: calc(100% / 5);\n}\n\n.tabs-router.bottom-menu a {\n  flex-direction: column;\n  border-top: 3px solid transparent;\n  font-size: 9px;\n  line-height: 22px;\n}\n\n.tabs-router.bottom-menu a.active {\n  font-weight: 600;\n  border-bottom: unset;\n  border-top: 3px solid #ff7a00;\n}\n\n.tabs-router.bottom-menu a .svg-wrap {\n  display: flex;\n  justify-content: center;\n  justify-items: center;\n  height: 24px;\n  width: 24px;\n}\n\n.tabs-router.bottom-menu a svg {\n  margin-right: 0;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(30px);\n  background: rgba(0, 0, 0, 0.75);\n  overflow: hidden;\n  overflow-y: auto;\n  transition: opacity 0.3s;\n  z-index: 999;\n  box-sizing: border-box;\n}\n\n.modal.vote-modal {\n  background: linear-gradient(\n    180deg,\n    #000000 5%,\n    #160E2D 30%,\n    #251640 67%\n  );\n}\n\n.modal.vote-modal .modal-wrapper {\n  display: block;\n  min-height: 100vh;\n}\n\n.modal.vote-modal .modal-content {\n  height: 100vh;\n  margin-right: auto;\n  margin-left: auto;\n  border-radius: unset;\n  border: none;\n  background: unset;\n}\n\n.modal.vote-modal .modal-content h2 {\n  max-width: unset;\n}\n\n.modal.vote-modal .vote-modal-close {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 50px auto 0 auto;\n  padding: 0;\n  height: 48px;\n  width: 48px;\n  min-width: unset;\n  cursor: pointer;\n  background: unset;\n}\n\n.modal.vote-modal .vote-modal-close img {\n  height: 100%;\n}\n\n.modal-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 100%;\n}\n\n.modal-content {\n  position: relative;\n  margin: 20px;\n  width: 100%;\n  max-width: 345px;\n  border-radius: 20px;\n  border: 2px solid rgb(43, 26, 75);\n  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;\n  padding: 43px 20px 37px 20px;\n  transform: translateY(-50px);\n  transition: opacity 0.3s, transform 0.3s;\n  box-sizing: border-box;\n}\n\n.modal-content h2 {\n  margin: 0;\n  font-weight: 900;\n  font-size: 20px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 0 0 10px #8e62df;\n}\n\n.modal-content .points {\n  display: flex;\n  justify-content: center;\n  margin: 26px 0;\n}\n\n.modal-content .points span {\n  position: relative;\n  display: inline-block;\n  margin-left: 12px;\n  font-family: Poppins, sans-serif;\n  font-weight: 900;\n  font-size: 38px;\n  line-height: 1;\n  color: #fff;\n  text-shadow:\n    3px 3px 0 #2B1A4B,\n    -3px 3px 0 #2B1A4B,\n    -2px -3px 0 #2B1A4B,\n    2px -3px 0 #2B1A4B;\n}\n\n.modal-content .points span:before {\n  content: attr(data-content);\n  position: absolute;\n  color: inherit;\n  font-weight: 900;\n  font-size: 38px;\n  text-shadow: 0 0 23px #ffb067;\n  z-index: -1;\n}\n\n.modal-content p {\n  font-weight: 500;\n  font-size: 12px;\n  text-align: center;\n  color: #fff;\n}\n\n.modal-content .button-large {\n  margin-top: 25px;\n  max-width: 279px;\n}\n\n.scores-container {\n  text-align: center;\n  color: white;\n  position: relative;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 20px 0;\n  background: linear-gradient(180deg, #000 12.25%, #160e2d 47.37%, #251640 71%);\n}\n\n.scores-inner {\n  padding-top: 24px;\n  margin: 0 auto;\n  max-width: 768px;\n  width: 100%;\n  overflow: hidden auto;\n}\n\n.scores-inner .users-list .loader-container {\n  position: static;\n  top: auto;\n  right: 0;\n  left: 0;\n  margin: auto;\n  padding: 47px 0 27px 0;\n}\n\n.scores-inner .users-list .loader-container p {\n  display: none;\n}\n\n.trigger {\n  height: 20px;\n  background: transparent;\n}\n\n.scores-main {\n  position: relative;\n  z-index: 1;\n  padding: 0 24px 17px 24px;\n}\n\n.my-info .user-item {\n  padding: 14px 25px 14px 14px;\n  border-radius: 20px;\n  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #ff7a00 100%);\n}\n\n.my-info .user-item .user-points span {\n  margin-left: 21px;\n}\n\n.top-users {\n  display: flex;\n  justify-content: center;\n  margin: 0;\n  padding: 0 0 60px 0;\n  list-style: none;\n}\n\n.top-users .top-user-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 74px;\n  padding: 0 25px;\n  box-sizing: border-box;\n}\n\n.top-users .top-user-item .user-title {\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.top-users .top-user-item .user-points {\n  margin-bottom: 10px;\n  font-size: 14px;\n  text-shadow: 1px 1px 0 #2B1A4B, -1px 1px 0 #2B1A4B, -1px -1px 0 #2B1A4B, 1px -1px 0 #2B1A4B;\n}\n\n.top-users .top-user-item .user-points span:before {\n  content: attr(data-content);\n  position: absolute;\n  color: inherit;\n  font-size: 14px;\n  text-shadow: 0 0 10px #ffb067;\n  z-index: -1;\n}\n\n.top-users .top-user-item .avatar-wrap {\n  position: relative;\n  user-select: none;\n}\n\n.top-users .top-user-item .user-rank {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -56px;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n}\n\n.top-users .top-user-item .user-rank span {\n  position: absolute;\n  top: 13px;\n  right: 0;\n  left: 0;\n  margin: auto;\n  text-align: center;\n  font-size: 20px;\n  color: #000;\n}\n\n.top-users .top-user-item.first-place {\n  position: relative;\n  margin-top: 0;\n  padding-top: 45px;\n  width: 137px;\n}\n\n.top-users .top-user-item.first-place:before {\n  content: '';\n  z-index: -1;\n  position: absolute;\n  top: 18px;\n  width: 137px;\n  height: 246px;\n  background: url('./assets/first-place-flag.png') no-repeat;\n}\n\n.top-users .top-user-item.first-place .user-avatar {\n  border-color: transparent !important;\n  background: linear-gradient(\n    to right,\n    rgb(255, 157, 67),\n    rgb(255, 255, 255),\n    rgb(255, 176, 103),\n    rgb(255, 122, 0)\n  );\n}\n\n.top-users .top-user-item.first-place .user-points {\n  margin-bottom: 5px;\n}\n\n.top-users .top-user-item.first-place .user-rank {\n  bottom: -54px;\n}\n\n.users-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.users-list .user-title {\n  color: #fff;\n}\n\n.user-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 17px 39px 16px 24px;\n  margin-bottom: 5px;\n  background: #0f0a1e;\n}\n\n.user-item .user-item-left {\n  display: flex;\n  align-items: center;\n}\n\n.user-avatar {\n  position: relative;\n  border-radius: 100%;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  user-select: none;\n}\n\n.user-avatar img {\n  height: 100%;\n  width: 100%;\n  border-radius: 100%;\n}\n\n.user-avatar .user-avatar-placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  font-weight: normal;\n  text-transform: uppercase;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.user-avatar .user-avatar-placeholder span {\n  opacity: .9;\n  filter: saturate(0.8);\n}\n\n.user-item .user-item-info {\n  margin-left: 15px;\n}\n\n.user-title {\n  margin: 0 0 2px 0;\n  text-align: left;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 1;\n  color: #ff7a00;\n}\n\n.user-rank {\n  margin: 0;\n  text-align: left;\n  font-weight: 700;\n  font-size: 14px;\n  color: #fff;\n}\n\n.user-points {\n  position: relative;\n  font-weight: 900;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 0 0 10px #8e62df;\n}\n\n.user-item .user-points {\n  border-left: 1px solid #2d1b4b;\n}\n\n.user-item .user-points span {\n  margin-left: 31px;\n}\n\n.coming-soon {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 15px;\n  box-sizing: border-box;\n  background-color: #251640;\n}\n\n.coming-soon .coming-soon-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto 23px auto;\n  width: 70px;\n  height: 70px;\n  border-radius: 100px;\n  background: #2b1a4b;\n}\n\n.coming-soon .coming-soon-icon svg {\n  fill: none;\n  stroke: #916e9c;\n}\n\n.coming-soon h1 {\n  font-weight: 900;\n  font-size: 20px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 0 0 10px #8e62df;\n}\n\n.coming-soon p {\n  max-width: 350px;\n  width: 100%;\n  margin: 0 auto;\n  font-weight: 500;\n  font-size: 12px;\n  text-align: center;\n  color: #916e9c;\n}\n\n.earn-points-container {\n  padding: 26px 26px 45px 26px;\n  overflow: hidden auto;\n}\n\n.earn-points-container ul {\n  padding: 0;\n  margin: 0 auto;\n  max-width: 768px;\n  width: 100%;\n  list-style: none;\n}\n\n.earn-points-item {\n  position: relative;\n  margin-bottom: 17px;\n  border-radius: 20px;\n  border: 2px solid rgb(43, 26, 75);\n  background: rgb(22, 13, 38);\n}\n\n.earn-points-item-inactive {\n  position: absolute;\n  background-color: #0F0A1E80;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n\n.earn-points-item:last-of-type {\n  margin-bottom: 0;\n}\n\n.earn-points-item.done .earn-points-bar {\n  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;\n}\n\n.earn-points-item .earn-points-bar {\n  border-top-right-radius: 18px;\n  border-top-left-radius: 18px;\n  height: 40px;\n  width: 100%;\n  background: linear-gradient(\n    135.87deg,\n    rgb(56, 35, 63) 2.841%,\n    rgb(43, 26, 75) 37.264%,\n    rgb(255, 122, 0) 96.87%);\n}\n\n.earn-points-item .earn-points-bar img {\n  margin-top: 21px;\n}\n\n.earn-points-item .earn-points-content {\n  z-index: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 33px 10px 26px 10px;\n  box-sizing: border-box;\n}\n\n.earn-points-item h2 {\n  margin-bottom: 16px;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 109%;\n  text-align: center;\n  color: #fff;\n}\n\n.earn-points-item .earn-points-title {\n  margin: 0 0 6px 0;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  text-transform: uppercase;\n  color: #ff7a00;\n}\n\n.earn-points-item .earn-points-value {\n  position: relative;\n  margin-bottom: 14px;\n  font-weight: 900;\n  font-size: 24px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 2px 2px 0 #2B1A4B, -2px 2px 0 #2B1A4B, -2px -2px 0 #2B1A4B, 2px -2px 0 #2B1A4B;\n}\n\n.earn-points-item .earn-points-value:before {\n  content: attr(data-content);\n  position: absolute;\n  color: inherit;\n  font-size: inherit;\n  text-shadow: 0 0 10px #ffb067;\n  z-index: -1;\n}\n\n.earn-points-item .button-wrap {\n  width: 100%;\n}\n\n.earn-points-item .button-large {\n  margin: 3px;\n  padding: 14px 5px;\n  min-width: auto;\n  max-width: 120px;\n  font-size: 14px;\n}\n\n.earn-points-item .button-large.button-pending {\n  pointer-events: none;\n  background: linear-gradient(180deg, #653db1 0%, #2b1a4b 100%);\n}\n\n.earn-points-item .button-large.button-pending:before {\n  background: linear-gradient(180deg, #2b1a4b 0%, #653db1 100%);\n}\n\n.earn-points-item .button-large.button-done {\n  position: relative;\n  margin: 0;\n  padding-left: 58px;\n  max-width: 125px;\n  text-align: left;\n  pointer-events: none;\n  text-shadow: unset;\n  border: 3px solid #321d09;\n  background: #854000;\n}\n\n.earn-points-item .button-large .button-inactive {\n  position: relative;\n  margin: 0;\n  padding-left: 58px;\n  max-width: 125px;\n  text-align: left;\n  pointer-events: none;\n  text-shadow: unset;\n  border: 3px solid #321d09;\n  background: #854000;\n}\n\n.earn-points-item .button-large.button-done:before {\n  content: '';\n  z-index: 1;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 23px;\n  border-radius: 100px;\n  width: 25px;\n  height: 25px;\n  background: #05ff0080;\n}\n\n.earn-points-item .button-large.button-done:after {\n  content: '';\n  z-index: 2;\n  position: absolute;\n  top: 20px;\n  left: 29px;\n  width: 11px;\n  height: 6px;\n  color: #fff;\n  border-bottom: solid 1px currentColor;\n  border-left: solid 1px currentColor;\n  transform: rotate(-45deg);\n}\n\n.earn-points-item p {\n  margin-top: 23px;\n  font-weight: 500;\n  font-size: 12px;\n  text-align: center;\n  color: #fff;\n}\n\n.earn-points-msg {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  max-width: 260px;\n  width: 100%;\n  margin: 10px auto 0 auto;\n}\n\n.earn-points-msg svg {\n  flex-shrink: 0;\n  margin: -4px 5px 0 0;\n}\n\n.earn-points-msg p {\n  margin: 0;\n  font-size: 8px;\n  line-height: 12px;\n  color: #fff;\n}\n\n.account-container {\n  padding-top: 24px;\n  flex-grow: 1;\n  overflow: hidden auto;\n}\n\n.account-inner {\n  max-width: 768px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 24px 25px 24px;\n  box-sizing: border-box;\n}\n\n.account-container .account-user {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n  padding: 0 8px;\n  font-weight: 900;\n  font-size: 16px;\n  text-align: center;\n  color: #fff;\n}\n\n.account-container .account-user .user-avatar {\n  margin-right: 12px;\n}\n\n.account-container .account-info {\n  margin: 0 0 7px 0;\n  padding: 0;\n  list-style: none;\n}\n\n.account-container .account-info li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 24px 8px 24px;\n  margin-bottom: 15px;\n  font-weight: 900;\n  font-size: 14px;\n  color: #fff;\n  border: 1px solid #000;\n  border-radius: 15px;\n  background: linear-gradient(180deg, #653db1 0%, #2b1a4b 100%);\n  box-sizing: border-box;\n}\n\n.account-container .account-info li:first-child span {\n  font-size: 23px;\n}\n\n.account-container .account-info li:last-child {\n  margin-bottom: 0;\n}\n\n.account-container .account-info li span {\n  display: flex;\n  align-items: center;\n}\n\n.account-container .account-info li span img {\n  margin-right: 10px;\n}\n\n.account-container .account-info h3 {\n  margin: 0 10px 0 0;\n  font-size: inherit;\n  line-height: 21px;\n  text-align: left;\n  text-transform: uppercase;\n}\n\n.account-footnote {\n  margin: 0 0 7px 0;\n  font-weight: 500;\n  font-size: 12px;\n  text-align: center;\n  color: #fff;\n}\n\n.account-stats {\n  border: 2px solid rgb(43, 26, 75);\n  border-radius: 20px;\n  background: rgb(22, 13, 38);\n}\n\n.account-stats .account-stats-title {\n  display: flex;\n  align-items: center;\n  padding: 0 22px;\n  height: 40px;\n  border-top-right-radius: 18px;\n  border-top-left-radius: 18px;\n  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;\n}\n\n.account-stats .account-stats-title h2 {\n  margin: 0;\n  font-weight: 700;\n  font-size: 14px;\n  color: #fff;\n  line-height: 21px;\n}\n\n.account-stats-list {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  grid-column-gap: 0;\n  grid-row-gap: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.account-stats-list li {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 14px 5px;\n  border-top: 1px solid #2b1a4b;\n}\n\n.account-stats-list li:first-child,\n.account-stats-list li:nth-child(2) {\n  border-top: unset;\n}\n\n.account-stats-list li:nth-child(odd) {\n  border-right: 1px solid #2b1a4b;\n}\n\n.account-stats-item-inner {\n  display: flex;\n  align-items: center;\n  max-width: 140px;\n  width: 100%;\n}\n\n.account-stats-left {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 10px;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: #2b1a4b;\n}\n\n.account-stats-right {\n  padding-top: 6px;\n  text-align: left;\n}\n\n.account-stats-right h3 {\n  margin: 0;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 18px;\n  color: #ff7a00;\n}\n\n.account-stats-right span {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 21px;\n  color: #fff;\n  white-space: pre;\n}\n\n.button-large.view-points {\n  padding: 22px 24px;\n  letter-spacing: 0;\n  text-shadow: 1px 2px 0 #000, -2px 2px 0 #000, -2px -1px 0 #000, 1px -1px 0 #000;\n  background: linear-gradient(180deg, #8e62df 0%,  #653db1 100%);\n}\n\n.button-large.view-points:before {\n  top: -1px;\n  left: -1px;\n  right: -1px;\n  bottom: -1px;\n}\n\n.election-list {\n  position: relative;\n  padding: 0;\n  margin: 18px auto 14px auto;\n  list-style: none;\n  max-width: 768px;\n  width: 100%;\n}\n\n.election-list:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  margin: auto;\n  backdrop-filter: blur(2px);\n  background: rgba(0, 0, 0, 0.01);\n}\n\n.election-list li {\n  margin-bottom: 10px;\n  border-radius: 20px;\n  background: rgb(22, 13, 38);\n}\n\n.election-list li:last-child {\n  margin-bottom: 0;\n}\n\n.election-list .election-title-wrap {\n  padding: 13px 5px 11px 5px;\n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n  background: linear-gradient(136deg, #38233f 2.64%, #2b1a4b 38.28%, #000 100%), #160d26;\n}\n\n.election-list .election-title-wrap p {\n  font-weight: 900;\n  font-size: 14px;\n  color: #fff;\n}\n\n.election-list .election-content {\n  display: flex;\n  justify-content: center;\n  padding: 15px 23px 18px 17px;\n  box-sizing: border-box;\n}\n\n.election-list .election-content-left {\n  margin-right: 11px;\n  height: 114px;\n  width: 114px;\n}\n\n.election-list .election-content-left img {\n  display: inline-block;\n  width: 100%;\n}\n\n.election-list .election-content-right {\n  display: flex;\n  flex-direction: column;\n}\n\n.election-list .election-candidate {\n  margin-bottom: 15px;\n}\n\n.election-list .election-candidate h3 {\n  margin: 0;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 1;\n  text-align: center;\n  color: #ff7a00;\n}\n\n.election-list .election-candidate p {\n  font-weight: 900;\n  font-size: 14px;\n  text-align: center;\n  color: #fff;\n}\n\n.election-list .election-actions-list {\n  display: flex;\n}\n\n.election-list .election-actions-list button {\n  margin: 0 0 5px 0;\n  border: 1px solid #fff;\n  border-radius: 100px;\n  padding: 9px 24px;\n  min-width: 80px;\n  height: 30px;\n  font-weight: 700;\n  font-size: 12px;\n  text-align: center;\n  color: #fff;\n  text-transform: uppercase;\n}\n\n.election-list .election-actions-list button.green {\n  background: #00851d;\n}\n\n.election-list .election-actions-list button.red {\n  background: #ef2424;\n}\n\n.election-list .election-actions-list p,\n.election-list .election-actions-list span {\n  font-weight: 900;\n  font-size: 10px;\n  line-height: 15px;\n  text-align: center;\n  color: #fff;\n}\n\n.election-list .election-action-wrap {\n  display: flex;\n  flex-direction: column;\n  margin-right: 24px;\n}\n\n.election-list .election-action-wrap:last-of-type {\n  margin-right: 0;\n}\n\n.vote-tweet.earn-points-item .earn-points-content {\n  padding-bottom: 20px;\n}\n\n.vote-tweet.earn-points-item .earn-points-title {\n  margin-bottom: 0;\n}\n\n.vote-tweet.earn-points-item .earn-points-value {\n  margin-bottom: 30px;\n}\n\n.vote-tweet.earn-points-item .button-large {\n  margin-bottom: 20px;\n}\n\n.bet-win-container {\n  flex: 1;\n  padding: 20px;\n  overflow: hidden auto;\n}\n\n.bet-win-container:before {\n  display: none;\n}\n\n.bet-win-container .bet-win-inner-wrap {\n  z-index: 99;\n  margin: 0 auto;\n  max-width: 346px;\n  width: 100%;\n}\n\n.bet-win-container .account-stats-title {\n  justify-content: center;\n  text-transform: uppercase;\n}\n\n.bet-win-container .account-stats-right span {\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.bet-win {\n  z-index: 1;\n  position: relative;\n  margin-bottom: 20px;\n  border-radius: 20px;\n  border: 2px solid rgb(43, 26, 75);\n  background: rgb(22, 13, 38);\n}\n\n.bet-win-content {\n  padding: 9px 20px 18px 20px;\n  box-sizing: border-box;\n}\n\n.bet-win-content.winner {\n  background: url('./assets/winner-celebrate.png') no-repeat;\n}\n\n.bet-win-content.winner .title {\n  color: #fff;\n}\n\n.bet-win-content .title {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 36px;\n  letter-spacing: 0.05em;\n  text-align: center;\n  color: #ff7a00;\n}\n\n.bet-win-content .points {\n  margin: 0 0 10px 0;\n  font-weight: 900;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  color: #fff;\n}\n\n.bet-win-content .team-card-wrap {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.bet-win-content .team-card {\n  padding: 9px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 20px;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.bet-win-content .team-card.no-cursor {\n  cursor: default;\n}\n\n.bet-win-content .team-card.red {\n  border-color: #961818;\n  box-shadow: 0 0 5px 0 #f00;\n  background: linear-gradient(180deg, rgba(239, 36, 36, 0.5) 0%, rgba(132, 22, 22, 0.5) 100%);\n}\n\n.bet-win-content .team-card.blue {\n  border-color: #000aff;\n  box-shadow: 0 0 5px 0 #000aff;\n  background: linear-gradient(180deg, rgba(0, 10, 255, 0.5) 0%, rgba(25, 34, 115, 0.5) 100%);\n}\n\n.bet-win-content .team-card .image-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 3px;\n  height: 120px;\n  width: 120px;\n  transition: 0.3s ease-out;\n}\n\n.bet-win-content .team-card .image-container img {\n  display: block;\n  height: 100%;\n  width: auto;\n}\n\n.bet-win-content.winner .team-card h2 {\n  color: #fff;\n}\n\n.bet-win-content .team-card h2 {\n  margin: 0;\n  font-weight: 900;\n  font-size: 32px;\n  line-height: 40px;\n  text-align: center;\n  color: #ff7a00;\n}\n\n.bet-win-content .team-card span {\n  font-weight: 900;\n  font-size: 24px;\n  line-height: 1;\n  text-align: center;\n  color: #fff;\n}\n\n.bet-win-content .pending-text {\n  font-weight: 900;\n  font-size: 14px;\n  text-align: center;\n  color: #ff7a00;\n  text-transform: uppercase;\n}\n\n.bet-win-content .bet-win-btn.closed {\n  pointer-events: none;\n  background: linear-gradient(180deg, #ff7a00 0%, rgba(255, 122, 0, 0.74) 100%);\n}\n\n.bet-win-content .bet-win-btn {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  padding: 12px 24px;\n  width: 121px;\n  min-width: unset;\n  height: 31px;\n  font-weight: 700;\n  font-size: 16px;\n  text-align: center;\n  color: #fff;\n  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);\n  border-radius: 100px;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.bet-win-content .bet-win-btn:before {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  right: -1px;\n  bottom: -1px;\n  border-radius: 100px;\n  background: rgba(255, 255, 255, 0.7);\n  z-index: -1;\n}\n\n.bet-win-content .bet-win-btn.orange:disabled {\n  pointer-events: none;\n  background: #160d26;\n}\n\n.bet-win-content .bet-win-btn.orange:disabled:before {\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  background: linear-gradient(180deg, #ff9d43 0%, #ff7a00 100%);\n}\n\n.bet-win-content .bet-win-btn.orange {\n  background: linear-gradient(180deg, #ff9d43 0%, #ff7a00 100%);\n}\n\n.bet-win-content .bet-win-btn.purple {\n  background: linear-gradient(180deg, #653db1 0%, rgba(101, 61, 177, 0.83) 100%);\n}\n\n.seed-ifo {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  height: 100%;\n  padding: 15px 0;\n  overflow-y: auto;\n}\n\n.seed-ifo-img {\n  width: 100%;\n  max-width: 388px;\n  height: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
